module.exports = __webpack_public_path__ + "static/media/docQuestion.760499af.svg";